import { databases, DB_ID, COLLECTIONS, ID } from "../appwrite";
import type { Models } from "appwrite";

export interface BlogPost {
    $id?: string;
    title: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    status: string;       // "Published" | "Draft"
    excerpt: string;
    imageUrl: string;
    featured: string;     // "true" | "false"
    content: string;
    slug: string;
}

const COL = COLLECTIONS.BLOG_POSTS;

export const blogService = {
    list: () =>
        databases
            .listDocuments(DB_ID, COL)
            .then((r) => r.documents as unknown as Array<BlogPost & Models.Document>),

    create: (data: Omit<BlogPost, "$id">) =>
        databases.createDocument(DB_ID, COL, ID.unique(), data),

    update: (id: string, data: Partial<BlogPost>) => {
        const {
            $id,
            $createdAt,
            $updatedAt,
            $permissions,
            $databaseId,
            $collectionId,
            ...updateData
        } = data as any;
        return databases.updateDocument(DB_ID, COL, id, updateData);
    },

    remove: (id: string) =>
        databases.deleteDocument(DB_ID, COL, id),
};
